/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

const Edit = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width={props.width || '16'}
         height={props.height || '16'}
         viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1545 1.56903C10.8054 0.918154 11.8606 0.918152 12.5115 1.56903L14.4306 3.48815C15.0815 4.13902 15.0815 5.19429 14.4306 5.84517L12.1092 8.16666L7.83301 3.89052L10.1545 1.56903ZM6.8902 4.83332L2.11406 9.60947C1.61396 10.1096 1.33301 10.7878 1.33301 11.4951V14.6667H4.50458C5.21182 14.6667 5.8901 14.3857 6.3902 13.8856L11.1663 9.10947L10.2235 8.16666L5.44739 12.9428C5.19734 13.1929 4.8582 13.3333 4.50458 13.3333H2.66634V11.4951C2.66634 11.1415 2.80682 10.8023 3.05687 10.5523L7.83301 5.77613L6.8902 4.83332ZM8.55687 6.49999L4.52827 10.5286L5.47108 11.4714L9.49967 7.4428L8.55687 6.49999ZM11.5687 2.51184C11.4385 2.38166 11.2275 2.38166 11.0973 2.51184L9.60915 3.99999L11.9997 6.39052L13.4878 4.90236C13.618 4.77219 13.618 4.56113 13.4878 4.43096L11.5687 2.51184Z"
        fill={props.fill || '#141928'}
      />
    </svg>
  );
};

Edit.displayName = 'Edit';

export default Edit;
